export default __webpack_public_path__ + "static/media/figma-logo.981dcbd2.svg";